// src/components/superadmin/CampusDashboard/StaffFormModal.jsx
import React, { useState } from "react";
import { MdClose } from "react-icons/md";
import "./StaffFormModal.css";

const StaffFormModal = ({ isOpen, onClose, onSave, campus, editingStaff }) => {
  const [formData, setFormData] = useState({
    name: editingStaff?.name || "",
    email: editingStaff?.email || "",
    phone: editingStaff?.phone || "",
    cnic: editingStaff?.cnic || "",
    designation: editingStaff?.designation || "",
    joining_date: editingStaff?.joining_date || "",
    gender: editingStaff?.gender || "",
    address: editingStaff?.address || "",
    salary: editingStaff?.salary || "",
    emergency_contact_name: editingStaff?.emergency_contact_name || "",
    emergency_contact_number: editingStaff?.emergency_contact_number || "",
    documents: editingStaff?.documents || [],
  });

  const [selectedFile, setSelectedFile] = useState(null);
  const [docName, setDocName] = useState("");
  const [docType, setDocType] = useState("");

  if (!isOpen) return null;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleAddDocument = () => {
    if (selectedFile && docName) {
      const reader = new FileReader();
      reader.onload = (e) => {
        const newDoc = {
          id: Date.now(),
          name: docName,
          type: docType || "Other",
          file_data: e.target.result,
          file_name: selectedFile.name,
          uploaded_at: new Date().toISOString(),
        };
        setFormData((prev) => ({
          ...prev,
          documents: [...prev.documents, newDoc],
        }));
        setSelectedFile(null);
        setDocName("");
        setDocType("");
        document.getElementById("staff-doc-input").value = "";
      };
      reader.readAsDataURL(selectedFile);
    }
  };

  const handleRemoveDocument = (docId) => {
    setFormData((prev) => ({
      ...prev,
      documents: prev.documents.filter((d) => d.id !== docId),
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Log the form data for debugging
    console.log("Form Data before validation:", formData);
    
    // Check required fields - trim to avoid whitespace issues
    const name = formData.name?.trim() || "";
    const email = formData.email?.trim() || "";
    const designation = formData.designation?.trim() || "";
    
    if (!name) {
      alert("Please enter the staff member's full name.");
      return;
    }
    if (!email) {
      alert("Please enter the staff member's email address.");
      return;
    }
    if (!designation) {
      alert("Please select a designation for the staff member.");
      return;
    }
    
    // Additional email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      alert("Please enter a valid email address.");
      return;
    }
    
    // Prepare data to save
    const staffData = {
      ...formData,
      campus_id: campus?.id,
    };
    
    console.log("Submitting staff data:", staffData);
    onSave(staffData);
  };

  return (
    <div className="staff-modal-overlay" onClick={onClose}>
      <div className="staff-modal-container" onClick={(e) => e.stopPropagation()}>
        <div className="staff-modal-header">
          <h2>{editingStaff ? "Edit Staff" : "Add Staff"}</h2>
          <button className="staff-modal-close" onClick={onClose}>
            <MdClose />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="staff-form">
          <div className="staff-form-grid">
            <div className="staff-form-group">
              <label>Full Name *</label>
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
                placeholder="Enter full name"
              />
            </div>

            <div className="staff-form-group">
              <label>Email *</label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
                placeholder="staff@example.com"
              />
            </div>

            <div className="staff-form-group">
              <label>Phone</label>
              <input
                type="text"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                placeholder="03XX-XXXXXXX"
              />
            </div>

            <div className="staff-form-group">
              <label>CNIC</label>
              <input
                type="text"
                name="cnic"
                value={formData.cnic}
                onChange={handleChange}
                placeholder="12345-1234567-1"
              />
            </div>

            <div className="staff-form-group">
              <label>Designation *</label>
              <select
                name="designation"
                value={formData.designation}
                onChange={handleChange}
                required
              >
                <option value="">Select Designation</option>
                <option value="Admin Staff">Admin Staff</option>
                <option value="Support Staff">Support Staff</option>
                <option value="Security">Security</option>
                <option value="Sweeper">Sweeper</option>
                <option value="Peon">Peon</option>
                <option value="Other">Other</option>
              </select>
            </div>

            <div className="staff-form-group">
              <label>Gender</label>
              <select name="gender" value={formData.gender} onChange={handleChange}>
                <option value="">Select Gender</option>
                <option value="Male">Male</option>
                <option value="Female">Female</option>
              </select>
            </div>

            <div className="staff-form-group">
              <label>Joining Date</label>
              <input
                type="date"
                name="joining_date"
                value={formData.joining_date}
                onChange={handleChange}
              />
            </div>

            <div className="staff-form-group">
              <label>Salary (PKR)</label>
              <input
                type="number"
                name="salary"
                value={formData.salary}
                onChange={handleChange}
                placeholder="Enter salary amount"
              />
            </div>

            <div className="staff-form-group" style={{ gridColumn: "1 / -1" }}>
              <label>Address</label>
              <input
                type="text"
                name="address"
                value={formData.address}
                onChange={handleChange}
                placeholder="Enter address"
              />
            </div>

            <div className="staff-form-group">
              <label>Emergency Contact Name</label>
              <input
                type="text"
                name="emergency_contact_name"
                value={formData.emergency_contact_name}
                onChange={handleChange}
                placeholder="Emergency contact name"
              />
            </div>

            <div className="staff-form-group">
              <label>Emergency Contact Number</label>
              <input
                type="text"
                name="emergency_contact_number"
                value={formData.emergency_contact_number}
                onChange={handleChange}
                placeholder="Emergency contact number"
              />
            </div>
          </div>

          {/* Documents Section */}
          <div className="staff-documents-section">
            <h4>📎 Documents</h4>

            <div className="staff-document-upload">
              <input
                type="file"
                id="staff-doc-input"
                onChange={(e) => setSelectedFile(e.target.files[0])}
                style={{ display: "none" }}
                accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
              />
              <button
                type="button"
                className="staff-btn-secondary"
                onClick={() => document.getElementById("staff-doc-input").click()}
              >
                Choose File
              </button>
              {selectedFile && <span className="staff-file-name">{selectedFile.name}</span>}
              <input
                type="text"
                placeholder="Document name"
                value={docName}
                onChange={(e) => setDocName(e.target.value)}
                className="staff-doc-name-input"
              />
              <select
                value={docType}
                onChange={(e) => setDocType(e.target.value)}
                className="staff-doc-type-select"
              >
                <option value="">Type</option>
                <option value="CNIC">CNIC</option>
                <option value="Degree">Degree</option>
                <option value="Experience Letter">Experience Letter</option>
                <option value="Contract">Contract</option>
                <option value="Other">Other</option>
              </select>
              <button
                type="button"
                className="staff-btn-primary"
                onClick={handleAddDocument}
                disabled={!selectedFile || !docName}
              >
                Add Document
              </button>
            </div>

            {formData.documents.length > 0 && (
              <div className="staff-document-list">
                {formData.documents.map((doc) => (
                  <div key={doc.id} className="staff-document-item">
                    <div>
                      <span className="staff-doc-name">{doc.name}</span>
                      <span className="staff-doc-meta">
                        {doc.type} • {doc.file_name || "File"}
                      </span>
                    </div>
                    <button
                      type="button"
                      className="staff-doc-remove"
                      onClick={() => handleRemoveDocument(doc.id)}
                    >
                      Remove
                    </button>
                  </div>
                ))}
              </div>
            )}
          </div>

          <div className="staff-form-actions">
            <button type="button" className="staff-btn-secondary" onClick={onClose}>
              Cancel
            </button>
            <button type="submit" className="staff-btn-primary">
              {editingStaff ? "Update Staff" : "Add Staff"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default StaffFormModal;